module.exports = "/_next/static/images/Pin@2x-bbdce3dbf455ac68203908849448e7e2.png";